import api from './client';

// Intercompany API
export const intercompanyAPI = {
  getEntries: (arg) => {
    // Accept both positional string (legacy) and object signature
    const params = typeof arg === 'string' || arg == null
      ? { entity_id: arg }
      : { entity_id: arg.entityId, scope: arg.scope, counterparty: arg.counterparty };
    return api.get('/intercompany', { params });
  },
  getBalances: (entityId) => api.get('/intercompany/balances', { params: { entity_id: entityId } }),
  getCounts: () => api.get('/intercompany/counts'),
  sync: () => api.post('/intercompany/sync'),
  reimburse: (fromEntity, toEntity, amount, reference, currency) =>
    api.post('/intercompany/reimburse', null, {
      params: { from_entity: fromEntity, to_entity: toEntity, amount, reference, currency },
    }),
  getPositions: ({ scope, entityId, displayCurrency, grouped } = {}) =>
    api.get('/intercompany/positions', {
      params: { scope, entity_id: entityId, display_currency: displayCurrency, grouped },
    }),
  // Single-source ledger: per-entry position contributions + fx_rates map,
  // feeds both the Positions net/breakdown and the Entries tab.
  getLedger: ({ scope, entityId, displayCurrency } = {}) =>
    api.get('/intercompany/ledger', {
      params: { scope, entity_id: entityId, display_currency: displayCurrency },
    }),
  // Cost recharges (cash-settled reimbursements between entities). Excluded
  // from loan positions on purpose; this is where they stay visible.
  getRecharges: ({ scope, entityId } = {}) =>
    api.get('/intercompany/recharges', { params: { scope, entity_id: entityId } }),
  settlementPreview: (body) => api.post('/intercompany/settlement/preview', body),
  settlementApply: (body) => api.post('/intercompany/settlement/apply', body),
};
